<template>
  <div class="order-item-wrap mb16 dt-hand" @click="handleOrderCardClick">
    <div class="order-item-head">
      <div class="d-flex align-items-center justify-content-between">
        <div class="lh21 bold fs-14" v-if="sourcePage !== PageNames.HOME_PAGE">
          {{ getOrderType }}
        </div>
        <!-- use class 'bg-green' for delivered, 'bg-yellow' for being-baked, 'bg-blue' for advance order -->
        <div
          class="tag-order-type"
          v-if="sourcePage !== PageNames.HOME_PAGE"
          :class="getOrderStateBgClass"
        >
          {{ getOrderState }}
        </div>
      </div>
      <div class="d-flex color-slaty">
        <div
          class="fs-12 mt2"
          v-if="sourcePage !== PageNames.HOME_PAGE && order?.store?.orderId"
        >
          Order #<span class="dt-link">{{ order?.store?.orderId }} </span>
        </div>
        <div class="fs-12 mt2" v-else>Order</div>
        <span class="color-x-grey-light plr4 fs-18"> | </span>
        <div class="fs-12 order-date mt2">
          {{ getDateInFormat() }}
        </div>
      </div>
    </div>
    <div class="order-item-content mt10">
      <div v-for="item in filterItems" :key="item?.itemId">
        <items-list :data-items="item" :data-price-card="false"></items-list>
      </div>
      <div
        class="more-items mb8"
        v-if="order?.items?.length > 3 && this.limit"
        @click.stop="showMore"
      >
        +{{ order?.items?.length - 3 }} <span>more</span>
      </div>
    </div>
    <!-- <div class="order-item-content mt10 border-bottom" v-else>
      <div v-for="item in order?.items" :key="item?.itemId">
        <items-list :data-items="item" :data-price-card="false"></items-list>
      </div>
      <div class="more-items mb8" v-if="order?.items?.length > 3">
        +{{ order?.items?.length - 3 }} <span>more</span>
      </div>
    </div> -->
    <div class="order-item-foot">
      <div class="d-flex align-items-center">
        <span class="fs-18 bold">
          <span class="rs">Rs.</span>{{ order?.netPrice }}
        </span>
        <span class="ver-seprator"></span>
        <span class="fs-12 color-slaty">{{ order?.items?.length }}</span>
        <span v-if="order?.items?.length > 1" class="color-slaty"
          >&nbsp;Items</span
        >
        <span v-else class="color-slaty">&nbsp;Item</span>
      </div>

      <div class="bold">
        <span
          class="btn small secondary br12"
          @click="trackAdvanceCtaHandler"
          v-if="
            order?.advanceOrder &&
            isOrderTrackable &&
            sourcePage != PageNames.HOME_PAGE
          "
          >Track</span
        >
        <span
          class="line-btn small br12"
          @click="reorderCtaHandler"
          v-else-if="!isOrderTrackable || sourcePage == PageNames.HOME_PAGE"
          >Reorder</span
        >
        <span
          class="btn small secondary br12"
          @click="trackCtaHandler"
          v-else-if="isOrderTrackable && sourcePage != PageNames.HOME_PAGE"
          >Track</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { OrderHistoryPages } from "../helpers/orderHistoryConstants";
import {
  OrderTypesCode,
  OrderTypesFromCode,
} from "../helpers/orderTypesConstants";
import {
  EVENT_CLICK_REORDER,
  EVENT_CLICK_TRACKORDER,
  EVENT_CLICK_ORDER_DETAIL,
} from "../helpers/analyticsEvents";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import PageNames from "../config/pageNames";

export default {
  name: "OrderItemCard",
  components: {
    ItemsList: defineAsyncComponent(() => import("./ItemsList.vue")),
  },
  props: {
    dataResults: { required: false, default: "" },
    sourcePage: { required: false, default: "" },
    activateOrderCardClick: { required: false, default: false },
    index: { required: false, default: 0 },
  },
  data() {
    return {
      PageNames,
      order: {},
      limit: 3,
    };
  },
  mounted() {
    this.order = this.dataResults;
  },
  methods: {
    getDateInFormat() {
      if (this.sourcePage == PageNames.HOME_PAGE) {
        return Utility.getDateStringFromTimeStamp(this.order?.orderTimeStamp);
      }
      let res = this.order?.advanceOrder
        ? this.order?.advanceOrderTimeStamp > Date.now()
          ? "Estimated delivery by " +
            Utility.getDateStringFromTimeStamp(
              this.order?.advanceOrderTimeStamp
            ) +
            " " +
            Utility.getAdvanceCardTimeStringFromTimeStamp(
              this.order?.advanceOrderTimeStamp
            )
          : Utility.getDateStringFromTimeStamp(
              this.order?.advanceOrderTimeStamp
            )
        : Utility.getDateStringFromTimeStamp(this.order?.orderTimeStamp);

      return res.replace(",", "");
    },
    reorderCtaHandler(event) {
      event.cancelBubble = true;
      event.preventDefault();
      EVENT_CLICK_REORDER({
        sectionPosition: this.index + 1,
        orderType: this.getOrderType,
        orderStatus: this.getOrderState,
        sectionName: "My Orders Page",
        category: "My orders",
        subcategory: "Reorder",
      });
      this.addToCartOnReorder(this.order?.id);
      Utility.sendToCartScreen();
    },
    addToCartOnReorder(item = "") {
      // let reorderedItems = LocalStorageFunc.getReorderedItems();
      // reorderedItems = [...reorderedItems, ...items];
      LocalStorageFunc.setReorderedItems(item);
    },
    trackCtaHandler(event) {
      event.cancelBubble = true;
      this.$store.commit(keyMapsMutation.UPDATE_ORDER_ID, this.order?.id);
      event.preventDefault();
      EVENT_CLICK_TRACKORDER({
        sectionPosition: this.index + 1,
        orderType: this.getOrderType,
        orderStatus: this.getOrderState,
      });
      LocalStorageFunc.setOrderSummary(this.order);
      Utility.sendToOrderTracking();
    },
    handleOrderCardClick(event) {
      let { status } = Utility.getOrderState(this.order);
      this.$store.commit(keyMapsMutation.UPDATE_ORDER_ID, this.order?.id);
      event.preventDefault();
      if (this.activateOrderCardClick) {
        EVENT_CLICK_ORDER_DETAIL({
          sectionPosition: this.index + 1,
          orderType: this.getOrderType,
          orderStatus: this.getOrderState,
        });
        LocalStorageFunc.setOrderSummary(this.order);
        if (
          this.order?.currentOrder ||
          (this.order?.advanceOrder && this.order?.advanceOrderInProgress)
        ) {
          switch (status) {
            case "PENDING":
              {
                // @todo implement proper condition for track order
                // redirects to track order detail page
                Utility.sendToOrderTracking();
              }
              break;
            case "FAILED": {
              LocalStorageFunc.setOrderHistoryPage(
                OrderHistoryPages.PREVIOUS_ORDERS_DETAIL
              );
              Utility.sendToOrderHistory();
            }
            case "CANCELLED":
              LocalStorageFunc.setOrderHistoryPage(
                OrderHistoryPages.PREVIOUS_ORDERS_DETAIL
              );
              Utility.sendToOrderHistory();
            case "SUCCESS":
              {
                // redirects to previous order detail page
                LocalStorageFunc.setOrderHistoryPage(
                  OrderHistoryPages.PREVIOUS_ORDERS_DETAIL
                );
                Utility.sendToOrderHistory();
              }
              break;
            default:
              {
                if (status <= 4) {
                  // @todo implement proper condition for track order
                  // redirects to track order detail page
                  Utility.sendToOrderTracking();
                } else if (status == 5 || status == 9) {
                  // redirects to previous order detail page
                  LocalStorageFunc.setOrderHistoryPage(
                    OrderHistoryPages.PREVIOUS_ORDERS_DETAIL
                  );
                  Utility.sendToOrderHistory();
                } else if (status == 10) {
                  // redirects to advanced order detail page
                  LocalStorageFunc.setOrderHistoryPage(
                    OrderHistoryPages.ADVANCED_ORDER_DETAIL
                  );
                  Utility.sendToOrderHistory();
                } else {
                  // @todo implement proper condition for track order
                  // redirects to track order detail page
                  Utility.sendToOrderTracking();
                }
              }
              break;
          }
        } else {
          LocalStorageFunc.setOrderHistoryPage(
            OrderHistoryPages.PREVIOUS_ORDERS_DETAIL
          );
          Utility.sendToOrderHistory();
        }
      }
    },
    trackAdvanceCtaHandler(event) {
      event.cancelBubble = true;
      this.$store.commit(keyMapsMutation.UPDATE_ORDER_ID, this.order?.id);
      event.preventDefault();
      EVENT_CLICK_TRACKORDER({
        sectionPosition: this.index + 1,
        orderType: this.getOrderType,
        orderStatus: this.getOrderState,
      });
      LocalStorageFunc.setOrderHistoryPage(
        OrderHistoryPages.ADVANCED_ORDER_DETAIL
      );
      LocalStorageFunc.setOrderSummary(this.order);
      Utility.sendToOrderHistory();
    },
    showMore() {
      this.limit = 0;
    },
  },
  computed: {
    getOrderType() {
      return (
        OrderTypesFromCode[this.order?.deliveryType] ||
        OrderTypesFromCode[this.order?.deliveryOrderType?.deliveryTypeCode] ||
        OrderTypesFromCode.DINEIN
      );
    },
    getOrderState() {
      let orderStatus = Utility.getOrderState(this.order);
      return orderStatus?.displayText || "Being Prepared";
    },
    isOrderTrackable() {
      return (
        this.order?.currentOrder ||
        (this.order?.advanceOrder && this.order?.advanceOrderInProgress)
      );
    },
    getOrderStateBgClass() {
      let orderStatus = Utility.getOrderState(this.order);
      return orderStatus?.displayBgClass || "bg-yellow";
    },
    filterItems() {
      return this.limit
        ? this.order?.items?.slice(0, this.limit)
        : this.order?.items;
    },
  },
};
</script>
